export default "__VITE_ASSET__3Zz4sSuU__"